module.exports = __webpack_public_path__ + "fonts/Raleway-Thin.9f5eec4e.ttf";